<template>
    <div class="learnworlds-button learnworlds-button-solid-brand learnworlds-button-normal learnworlds-element" @click="enrollButtonClicked">
        <span>
            <div>
                <span class="v-bottom">Subscribe now!</span>
                <span class="v-bottom">
                    <strong> {{subscriptionPriceLabel}}</strong>
                </span>
            </div>
        </span>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "SubscriptionLayout1",
        mixins: [ComponentTemplatesMixin],
        props: {
            subscription : {
                type: Object
            }
        },
        computed: {
            subscriptionPriceLabel () {
                if (!this.subscription.id) {
                    return "";
                }

                let intervalLabel = "";
                let intervalTypeLabel = this.subscription.interval_type;

                if (typeof this.subscription.interval_type !== 'undefined' && typeof this.subscription.interval !== 'undefined') {
                    intervalTypeLabel = this.$t('common.' + this.subscription.interval_type);

                    if (this.subscription.interval > 1) {
                        intervalTypeLabel = this.$t('common.' + this.subscription.interval_type + 's');
                        intervalLabel = this.subscription.interval;
                    }
                }

                return `${this.subscription.currency}${this.subscription.price} / ${intervalLabel} ${intervalTypeLabel}`;
            }
        },
        methods: {
            enrollButtonClicked () {
                this.emitAction('subscription-clicked',this.subscription);
            },
        }
    }
</script>

